import type {
  WakeLoopEnvPreset,
  WakeLoopPathResolutionInput,
} from "../config/paths";
import { resolveWakeLoopEnvPreset } from "../config/paths";
import type { UninstallScope, UninstallScopeInput } from "./types";

export const ALL_UNINSTALL_LANES = [
  "prod",
  "dev-local",
  "canary",
] as const satisfies readonly WakeLoopEnvPreset[];

export function resolveCurrentUninstallLane(
  input: WakeLoopPathResolutionInput = {}
): WakeLoopEnvPreset {
  return resolveWakeLoopEnvPreset(input);
}

export function resolveUninstallScope(
  input: UninstallScopeInput = {}
): UninstallScope {
  if (input.allLanes === true) {
    return {
      kind: "all-lanes",
      lanes: [...ALL_UNINSTALL_LANES],
    };
  }

  return {
    kind: "current-lane",
    lane: resolveCurrentUninstallLane(input),
  };
}

export function listScopeLanes(
  scope: UninstallScope
): readonly WakeLoopEnvPreset[] {
  return scope.kind === "all-lanes" ? scope.lanes : [scope.lane];
}

export function resolveLaneUserFacingCommand(lane: WakeLoopEnvPreset): string {
  switch (lane) {
    case "dev-local":
      return "wakeloop-dev";
    case "canary":
      return "wakeloop-canary";
    default:
      return "wakeloop";
  }
}
